import React, { useState, useEffect } from "react";

import { auth } from "../../../Firebase/firebase";
import { connect } from "react-redux";
import * as actionCreators from "../../../Store/actions/index";
import { priceFormater } from "../../Utility/Utility";
import Spinner from "../../UI/spinner/Spinner";
import classes from "./GridView.module.css";
import carImg from "../../../assets/Img/carIMg.png";
import camera from "../../../assets/svg/camera.svg";
import heart from "../../../assets/svg/balckHeart.svg";
import redHeart from "../../../assets/svg/redHeart.svg";
import fullStar from "../../../assets/svg/star.svg";
import halfStar from "../../../assets/svg/starHalf.svg";
import emptyStar from "../../../assets/svg/starOutline.svg";
// import like from "../../../assets/svg/like.svg";
import doubleQoute from "../../../assets/Img/doubleQoute.png";
import HeartSpin from "../../UI/spinner/HeartSpin";

const GridView = (props) => {
    const [currentItemWishing, setCurrentItemWishing] = useState(null);
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    const checkItemIsWishLIsted = (itemId) => {
        let isWishItem = false;
        let wishArray = localStorage.getItem('myWish');
        if (props.user && props.wishIdsArray && wishArray) {
            wishArray = wishArray.split(',');
            isWishItem = wishArray.some((id) => {
                return +id === itemId
            })
        }
        return isWishItem
    }
    const addItmeToWishList = (itemId, userIsAuth) => {
        if (!props.user) {
            props.showAuthHandler('signIn')
        }
        else {
            const itemIsWishListed = checkItemIsWishLIsted(itemId);
            if (!itemIsWishListed) {
                let token = localStorage.getItem('idToken')
                if (!token) {
                    const fireUser = auth.currentUser
                    if (fireUser) {
                        fireUser.getIdToken().then(newToken => {
                            token = newToken
                            props.AddItemToWishList(itemId, token)
                        })
                    }
                    else {
                        console.log(fireUser)
                    }
                }
                else {
                    props.AddItemToWishList(itemId, token)
                }
            }
            else {
                console.log(itemId, userIsAuth, 'in my WishList')
            }
        }
    };
    let item = <Spinner />;
    if (props.girdVehicleItems.data) {
        let dataArray = props.girdVehicleItems.data;
        // const sorteData = sortter(props.sortT, dataArray)
        //#####################################################################################
        item = dataArray.map(gridItem => {
            let mediaImg = carImg;
            let isWishItem = false;
            let wishArray = localStorage.getItem('myWish');
            if (gridItem.media.length >= 1) {
                try {
                    mediaImg = gridItem.media.filter(img => {
                        return img.name === 'front';
                    })[0].url;
                } catch (error) {
                    mediaImg = gridItem.media[0].url;
                }
            }
            if (props.user && props.wishIdsArray && wishArray) {
                wishArray = wishArray.split(',');
                isWishItem = wishArray.some((id) => {
                    return +id === gridItem.id
                })
            }
            const tailer = mediaImg.slice(-4);
            return (
                <div className={classes.GridViewItem} key={gridItem.id} >
                    <div className={classes.itemImage} onClick={() => props.routProp.history.push(`/Detail?vehicle=${gridItem.id}&type=${gridItem.vehicle_type}`)}>
                        <div className={classes.positioningCamera}>
                            <img src={camera} alt='num' /><small>{gridItem.media.length} +</small>
                        </div>
                        {tailer === '.mp4' ?
                            <video width='100%' height='200px'>
                                <source src={mediaImg} type='video/mp4' />
                            </video>
                            :
                            <img src={mediaImg} alt='car images' width='100%' height='200px' />
                        }
                        {props.addingItem && currentItemWishing === gridItem.id ?
                            <div className={classes.AddingWish}>
                                <HeartSpin />
                            </div>
                            :
                            <div
                                className={classes.positioningHeart}
                                onClick={(event) => {
                                    event.stopPropagation()
                                    setCurrentItemWishing(gridItem.id)
                                    addItmeToWishList(gridItem.id, props.user !== null)
                                }}>
                                <img src={isWishItem ? redHeart : heart} alt='num' />
                            </div>
                        }
                    </div>
                    <div
                        className={classes.ItemInfo}
                        onClick={(event) => {
                            props.routProp.history.push(`/Detail?vehicle=${gridItem.id}&type=${gridItem.vehicle_type}`)
                        }}
                    >
                        <h6>{gridItem.title}</h6>
                        <div className={classes.itemDetails}>
                            <div className={classes.SellerPitch}>
                                {/* <img src={doubleQoute} alt=''/>  */}
                                <p>Seller's Picthc </p>
                                {gridItem.seller_pitch}
                            </div>
                            <div className={classes.DetailInfo} >
                                <div className={classes.VerticalInfo}>
                                    <img src={doubleQoute} alt='' />
                                    <p>{gridItem.condition}</p>
                                    {gridItem.is_featured ? <p>Featured</p> : null}
                                    <p>{gridItem.body_type}</p>
                                </div>
                                <div className={classes.horizintalInfo}>
                                    <div className={classes.Group}>
                                        <p>milage</p>
                                        <p> {gridItem.mileage} </p>
                                    </div>
                                    <div className={classes.Group}>
                                        <p>Location</p>
                                        <p>{gridItem.state ? gridItem.state.name : null}</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className={classes.Dealer}>
                        <div className={classes.DealerName}>
                            <p>{gridItem.seller.name}</p>
                            <img src={fullStar} alt='rate1' />
                            <img src={fullStar} alt='rate2' />
                            <img src={fullStar} alt='rate3' />
                            <img src={halfStar} alt='rate4' />
                            <img src={emptyStar} alt='rate5' />
                            {/* <img className={classes.Like} src={like} alt='like' width='10%' /> */}
                        </div>
                        <div className={classes.Dealercontact}>
                            <p>{priceFormater(gridItem.price)}</p>
                            <small onClick={() => {
                                props.onToggelContactNow(gridItem.seller.id, gridItem.seller.name, gridItem.seller.phone)
                            }}>contact Now</small >
                        </div>
                    </div>
                </div>
            );
        }
        )
    }

    return (
        <div className={classes.GridView}>
            {item}
        </div>
    );
};

const mapDispatchToProps = dispatch => {
    return {
        onToggelContactNow: (id, name, phone) => { dispatch(actionCreators.toggelContactShow(id, name, phone)) }
    }
};

export default connect(null, mapDispatchToProps)(GridView);